import { useEffect, useState } from "react";
import { ChevronUp } from "lucide-react";

export default function BackToTop({ offset = "right-6 bottom-24", testId = "back-to-top" }) {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 600);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    if (!visible) return null;
    return (
        <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            data-testid={testId}
            aria-label="Volver arriba"
            className={`fixed ${offset} z-30 w-10 h-10 inline-flex items-center justify-center rounded-full bg-eclipse-primary text-white shadow-lg hover:scale-110 active:scale-95 transition-transform`}
        >
            <ChevronUp className="w-5 h-5" strokeWidth={2.5} />
        </button>
    );
}
